import React from "react";
import { Link } from "react-router-dom";
import TeachingStaffData from "../../data/TeachingStaffData";

const TeachersHomePageComponent = () => {
  const truncateText = (text, wordLimit) => {
    const words = text.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return text;
  };

  return (
    <div className="flex justify-center mb-5">
      <div className="max-w-6xl">
        <div className="my-10 mx-5 ">
          <div>
            <p className="font-bold text-2xl my-5 text-center">
              Members of the Teaching Staff
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 space-y-7 md:space-y-0">
            {TeachingStaffData.map((teacher) => (
              <Link to={`/about/teaching-staff/${teacher.id}`} key={teacher.id}>
                <div className="group space-y-3">
                  <div className="w-full h-96 sm:h-[500px] lg:h-80 overflow-hidden rounded-md border-2 border-sddarkgray/60">
                    <img
                      src={teacher.image}
                      alt={teacher.name}
                      className="w-full h-full object-top object-cover transform transition-transform duration-500 ease-in-out group-hover:scale-110"
                    />
                  </div>
                  <div className="h-[200px] md:h-[150px] flex flex-col space-y-5">
                    <div>
                      <div className="border-b-2 group-hover:text-sdorange group-hover:border-sdorange inline-block">
                        <p className="font-bold">{teacher.name}</p>
                      </div>
                    </div>

                    <div>
                      <p className="text-slate-500 group-hover:text-sddarkgray">
                        {truncateText(teacher.aboutExecutive, 20)}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeachersHomePageComponent;
